/** 快捷键类型 */
export enum HotkeyType {
    /** 剪切 */
    CUT = 'cut',
    /** 复制 */
    COPY = 'copy',
    /** 粘贴 */
    PASTE = 'paste',
    /** 退出 */
    ESC = 'esc',
    /** 删除 */
    DELETE = 'delete',
    /** 全选 */
    SELECT_ALL = 'selectAll',
    /** 空格 */
    SPACE = 'space',
}
